import React from 'react';
import {WeaNewScroll} from 'ecCom';
import Resizable from './react-resizable/Resizable';
import Background from '../wea-portal-background';

import GridLayout from './GridLayout';

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getLayoutSize = this.getLayoutSize.bind(this);
        this.onResize = this.onResize.bind(this);
        this.getElement = this.getElement.bind(this);
    }

    componentDidMount() {
        const {layout = {}} = this.props;
        this.getLayoutSize(layout);
    }

    componentWillReceiveProps(nextProps) {
        const {layout = {}} = nextProps;
        this.getLayoutSize(layout);
    }

    render() {
        const {isSetting, layoutType, layout = {}, element = {}} = this.props;
        const {
            middle: middleLayout = {},
            top: topLayout = {},
            bottom: bottomLayout = {},
            left: leftLayout = {},
            right: rightLayout = {}
        } = layout;
        const {
            middle: middleElements = [],
            top: topElements = [],
            bottom: bottomElements = [],
            left: leftElements = [],
            right: rightElements = []
        } = element;
        const {
            topWidth = 0,
            topHeight = 0,
            bottomWidth = 0,
            bottomHeight = 0,
            leftWidth = 0,
            leftHeight = 0,
            rightWidth = 0,
            rightHeight = 0,
            middleWidth = 0,
            middleHeight = 0
        } = this.state;

        const Top = (
            <div ref={(top) => this.top = top} className="wea-portal-layout-top" style={{height: topHeight}}>
                <Background background={topLayout.background || {}}/>
                <GridLayout
                    {...this.props}
                    ref={(topLayout) => this.topLayout = topLayout}
                    isSetting={isSetting}
                    layoutType={layoutType}
                    position="top"
                    width={topWidth}
                    height={topHeight}
                    layout={topLayout}
                    elements={topElements}
                />
            </div>
        );

        const Left = (
            <div ref={(left) => this.left = left} className="wea-portal-layout-middle-left" style={{width: leftWidth}}>
                <Background background={leftLayout.background || {}}/>
                <WeaNewScroll height="100%">
                    <div className="wea-portal-layout-scroll">
                        <GridLayout
                            {...this.props}
                            ref={(leftLayout) => this.leftLayout = leftLayout}
                            isSetting={isSetting}
                            layoutType={layoutType}
                            position="left"
                            width={leftWidth}
                            height={leftHeight}
                            layout={leftLayout}
                            elements={leftElements}
                        />
                    </div>
                </WeaNewScroll>
            </div>
        );

        const Middle = (
            <div ref={(middle) => this.middle = middle} className="wea-portal-layout-middle-middle" style={{left: leftWidth, right: rightWidth}}>
                <WeaNewScroll height="100%">
                    <div className="wea-portal-layout-scroll">
                        <GridLayout
                            {...this.props}
                            ref={(middleLayout) => this.middleLayout = middleLayout}
                            isSetting={isSetting}
                            layoutType={layoutType}
                            position="middle"
                            width={middleWidth}
                            height={middleHeight}
                            layout={middleLayout}
                            elements={middleElements}
                        />
                    </div>
                </WeaNewScroll>
            </div>
        );

        const Right = (
            <div ref={(right) => this.right = right} className="wea-portal-layout-middle-right" style={{width: rightWidth}}>
                <Background background={rightLayout.background || {}}/>
                <WeaNewScroll height="100%">
                    <div className="wea-portal-layout-scroll">
                        <GridLayout
                            {...this.props}
                            ref={(rightLayout) => this.rightLayout = rightLayout}
                            isSetting={isSetting}
                            layoutType={layoutType}
                            position="right"
                            width={rightWidth}
                            height={rightHeight}
                            layout={rightLayout}
                            elements={rightElements}
                        />
                    </div>
                </WeaNewScroll>
            </div>
        );

        const Bottom = (
            <div ref={(bottom) => this.bottom = bottom} className="wea-portal-layout-bottom" style={{height: bottomHeight}}>
                <Background background={bottomLayout.background || {}}/>
                <GridLayout
                    {...this.props}
                    ref={(bottomLayout) => this.bottomLayout = bottomLayout}
                    isSetting={isSetting}
                    layoutType={layoutType}
                    position="bottom"
                    width={bottomWidth}
                    height={bottomHeight}
                    layout={bottomLayout}
                    elements={bottomElements}
                />
            </div>
        );

        const TopResizable = (
            <Resizable
                {...this.props}
                className="wea-portal-layout-top-resizable"
                axis={isSetting ? 'y' : 'none'}
                height={topHeight}
                onResize={(event, {element, size}) => {
                    this.onResize('top', size.height);
                }}
                draggableOpts={{offsetParent: document.body}}
                dragPosition="bottom"
            >
                {Top}
            </Resizable>
        );

        const LeftResizable = (
            <Resizable
                {...this.props}
                className="wea-portal-layout-left-resizable"
                axis={isSetting ? 'x' : 'none'}
                width={leftWidth}
                onResize={(event, {element, size}) => {
                    this.onResize('left', size.width);
                }}
                draggableOpts={{offsetParent: document.body}}
                dragPosition="right"
            >
                {Left}
            </Resizable>
        );

        const RightResizable = (
            <Resizable
                {...this.props}
                className="wea-portal-layout-right-resizable"
                axis={isSetting ? 'x' : 'none'}
                width={rightWidth}
                onResize={(event, {element, size}) => {
                    this.onResize('right', size.width);
                }}
                draggableOpts={{offsetParent: document.body}}
                dragPosition="left"
            >
                {Right}
            </Resizable>
        );

        const BottomResizable = (
            <Resizable
                {...this.props}
                className="wea-portal-layout-bottom-resizable"
                axis={isSetting ? 'y' : 'none'}
                height={bottomHeight}
                onResize={(event, {element, size}) => {
                    this.onResize('bottom', size.height);
                }}
                draggableOpts={{offsetParent: document.body}}
                dragPosition="top"
            >
                {Bottom}
            </Resizable>
        );

        return (
            <div ref={(layout) => this.layout = layout} className="wea-portal-layout">
                {topHeight > 0 && (isSetting ? TopResizable : Top)}
                <div className="wea-portal-layout-middle" style={{top: topHeight, bottom: bottomHeight}}>
                    {leftWidth > 0 && (isSetting ? LeftResizable : Left)}
                    {middleWidth > 0 && Middle}
                    {rightWidth > 0 && (isSetting ? RightResizable : Right)}
                </div>
                {bottomHeight > 0 && (isSetting ? BottomResizable : Bottom)}
            </div>
        );
    }

    getLayoutSize(layout = {}) {
        const {top = {}, bottom = {}, left = {}, right = {}} = layout;

        const layoutWidth = $(this.layout).width();
        const layoutHeight = $(this.layout).height();

        const topWidth = top.visible ? layoutWidth : 0;
        const topHeight = top.visible ? top.height : 0;

        const bottomWidth = bottom.visible ? layoutWidth : 0;
        const bottomHeight = bottom.visible ? bottom.height : 0;

        const leftWidth = left.visible ? left.width : 0;
        const leftHeight = left.visible ? layoutHeight - topHeight - bottomHeight : 0;

        const rightWidth = right.visible ? right.width : 0;
        const rightHeight = right.visible ? layoutHeight - topHeight - bottomHeight : 0;

        const middleWidth = layoutWidth - leftWidth - rightWidth;
        const middleHeight = layoutHeight - topHeight - bottomHeight;

        this.setState({
            topWidth,
            topHeight,
            bottomWidth,
            bottomHeight,
            leftWidth,
            leftHeight,
            rightWidth,
            rightHeight,
            middleWidth,
            middleHeight
        });
    }

    onResize(position, size) {
        const {layout = {}} = this.props;
        const {top = {}, bottom = {}, left = {}, right = {}} = layout;

        if (position === 'top') {
            this.props.onChange({top: {...top, height: size}});
        } else if (position === 'bottom') {
            this.props.onChange({bottom: {...bottom, height: size}});
        } else if (position === 'left') {
            this.props.onChange({left: {...left, width: size}});
        } else if (position === 'right') {
            this.props.onChange({right: {...right, width: size}});
        }
    }

    getElement() {
        const topElements = this.topLayout && this.topLayout.getElements();
        const bottomElements = this.bottomLayout && this.bottomLayout.getElements();
        const leftElements = this.leftLayout && this.leftLayout.getElements();
        const rightElements = this.rightLayout && this.rightLayout.getElements();
        const middleElements = this.middleLayout && this.middleLayout.getElements();

        const element = {};
        topElements && (element.top = topElements);
        bottomElements && (element.bottom = bottomElements);
        leftElements && (element.left = leftElements);
        rightElements && (element.right = rightElements);
        middleElements && (element.middle = middleElements);

        return element;
    }
}

export default Layout;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-layout/Layout.js